import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

/**
 * For users with the `wastics_admin` realm role, send /dashboard → /admin
 * (the admin overview tiles are more useful as their landing page than the
 * generic dashboard). Other roles fall through and see the regular dashboard.
 *
 * Runs after AuthGuard so authentication + token refresh have already happened.
 */
export const wasticsAdminDashboardRedirectGuard: CanActivateFn = () => {
  const keycloak = inject(KeycloakService);
  const router = inject(Router);
  const roles = keycloak.getUserRoles?.() ?? [];
  if (roles.includes('wastics_admin')) {
    return router.parseUrl('/admin');
  }
  return true;
};
